import { __makeTemplateObject } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/system';
import { Typography } from '@mui/material';
import ZigSlider from '../../../../inputs/ZigSlider/index.js';

var StyledZigSlider = styled(ZigSlider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 9px;\n\n  .MuiSlider-thumb {\n    width: 18px;\n    height: 18px;\n  }\n"], ["\n  padding: 0 9px;\n\n  .MuiSlider-thumb {\n    width: 18px;\n    height: 18px;\n  }\n"])));
var Value = styled(Typography, {
    shouldForwardProp: function (p) { return p !== "showPct"; },
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 15px;\n  color: ", ";\n\n  &::after {\n    content: \"", "\";\n    font-size: 10px;\n    position: relative;\n    top: -6px;\n  }\n"], ["\n  font-size: 15px;\n  color: ", ";\n\n  &::after {\n    content: \"", "\";\n    font-size: 10px;\n    position: relative;\n    top: -6px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.paleBlue;
}, function (_a) {
    var showPct = _a.showPct;
    return (showPct ? "%" : "");
});
var templateObject_1, templateObject_2;

export { StyledZigSlider, Value };
